var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 8,
    fill: "#44546F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 9.89844L25.555 10.2684C29.398 12.8304 33.208 14.1004 37 14.1004H38V26.6004C38 34.6744 32.21 40.1004 25 40.1004C17.79 40.1004 12 34.6744 12 26.6004V14.1004H13C16.792 14.1004 20.602 12.8304 24.445 10.2684L25 9.89844ZM24 12.9034C20.8 14.7694 17.582 15.8234 14.352 16.0524L14 16.0724V26.6004C14 33.1584 18.347 37.5914 24 38.0594V12.9034ZM26 12.9034V38.0604C31.654 37.5924 36 33.1594 36 26.6014V16.0724L35.648 16.0524C32.418 15.8224 29.2 14.7704 26.001 12.9044L26 12.9034Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card4.af31827f98732e2f884114b2cf69306d.svg";
export { ForwardRef as ReactComponent };